<template>
  <RouterView />
</template>

<script>
export default {
  name: 'TheWorkDocumentRouter'
}
</script>
